module.exports = flarum.core.compat['components/PostMeta'];